import { render, staticRenderFns } from "./TrailerStatusFrag.vue?vue&type=template&id=637b7f1a"
import script from "./TrailerStatusFrag.vue?vue&type=script&lang=js"
export * from "./TrailerStatusFrag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports